import VueRouter from 'vue-router';
import { modalService } from '@gig/magic-common';
import '@gig/magic-pagcor';
import {
    IFormBuilderStepConfiguration,
    IFormBuilderState,
} from '@gig/magic-form-builder';
import { isPAGCOR, Jurisdiction } from '@gig/magic-jurisdictions';
import {
    USER_JURISDICTION_QUERY,
    USER_LOGGED_IN_QUERY,
} from '@gig/magic-messages';
import { isReturningUser } from '../../../util';

interface IMagicCorexUserDetailsElement extends HTMLElement {
    formConfig: IFormBuilderStepConfiguration[];
    initialFormState: IFormBuilderState;
}

let modalAlreadyShown = false;

export async function relevantInformationGuard(router: VueRouter) {
    router.beforeEach(async (to, from, next) => {
        if (await shouldShowModal()) {
            modalAlreadyShown = true;
            openModal();
        }

        next();
    });
}

async function openModal() {
    const modal = document.createElement(
        'magic-pagcor-relevant-information-modal',
    ) as IMagicCorexUserDetailsElement;

    const modalOptions = {
        dismissible: false,
        dismissibleBackdrop: false,
        displayOnTop: true,
        keepAfterClear: true,
        showAsModalOnMobile: true,
    };

    modalService.open(null, modal, modalOptions);
}

async function shouldShowModal() {
    const isLoggedIn = await window.queryBus.query<boolean>(
        USER_LOGGED_IN_QUERY,
    );

    const currentJurisdiction = await window.queryBus.query<Jurisdiction>(
        USER_JURISDICTION_QUERY,
    );

    return (
        isPAGCOR(currentJurisdiction) &&
        !isLoggedIn &&
        !modalAlreadyShown &&
        !isReturningUser()
    );
}
